(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexora-cepillo-antistatico"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

  // Forzar 1 columna en mobile para la grilla de pasos
  function fixGridCepillo() {
    var grid = document.getElementById('nxp-reasons-grid-cepillo');
    if (grid) {
      if (window.innerWidth <= 768) {
        grid.style.setProperty('grid-template-columns', '1fr', 'important');
      } else {
        grid.style.setProperty('grid-template-columns', 'repeat(3, 1fr)', 'important');
      }
    }
  }
  fixGridCepillo();
  window.addEventListener('resize', fixGridCepillo);

  // Comprar ahora
  var btnBuy = document.getElementById('nxp-btn-buy');
  if (btnBuy) {
    btnBuy.addEventListener('click', function() {
      var variantId = document.getElementById('nxp-variant-hidden') ? document.getElementById('nxp-variant-hidden').value : null;
      var qty = document.getElementById('nxp-quantity-input') ? document.getElementById('nxp-quantity-input').value : 1;
      if (variantId) {
        window.location.href = '/checkout?variant=' + variantId + '&quantity=' + qty;
      }
    });
  }

  // Social proof rotativo
  var socialTextEl = document.getElementById('nxp-social-text');
  var compradores = [
    'Romina de Córdoba compró hace 3 minutos',
    'Valentina de CABA compró hace 7 minutos',
    'Micaela de Rosario compró hace 11 minutos',
    'Julieta de La Plata compró hace 14 minutos',
    'Camila de Mendoza compró hace 19 minutos',
    'Florencia de Santa Fe compró hace 22 minutos',
    'Natalia de Mar del Plata compró hace 28 minutos',
    'Daniela de Tucumán compró hace 31 minutos',
    'Sofía de Salta compró hace 35 minutos',
    'Luciana de Entre Ríos compró hace 41 minutos'
  ];
  function randomComprador() { return compradores[Math.floor(Math.random() * compradores.length)]; }
  if (socialTextEl) {
    socialTextEl.textContent = randomComprador();
    setInterval(function() { socialTextEl.textContent = randomComprador(); }, 15000);
  }

  // Countdown timer
  var timerEl = document.getElementById('nxp-timer');
  if (timerEl) {
    var seconds = 19 * 60 + 59;
    setInterval(function() {
      if (seconds > 0) seconds--;
      timerEl.textContent = Math.floor(seconds/60).toString().padStart(2,'0') + ':' + (seconds%60).toString().padStart(2,'0');
    }, 1000);
  }

  // Bundle selector + oversell prevention
  function actualizarBundles(stock) {
    document.querySelectorAll('.nxp-bundle').forEach(function(bundle) {
      var radio = bundle.querySelector('input');
      var qty = parseInt(radio ? radio.value : 1);
      if (qty > stock) {
        bundle.classList.add('nxp-bundle-disabled');
        if (bundle.classList.contains('nxp-bundle-selected')) {
          bundle.classList.remove('nxp-bundle-selected');
          var primerBundle = document.querySelector('.nxp-bundle');
          if (primerBundle) {
            primerBundle.classList.add('nxp-bundle-selected');
            var primerRadio = primerBundle.querySelector('input');
            if (primerRadio) {
              primerRadio.checked = true;
              var qtyInput = document.getElementById('nxp-quantity-input');
              if (qtyInput) qtyInput.value = 1;
            }
          }
        }
      } else {
        bundle.classList.remove('nxp-bundle-disabled');
      }
    });
  }

  var variantSelect = document.getElementById('nxp-variant-id');
  if (variantSelect) {
    var initialOption = variantSelect.options[variantSelect.selectedIndex];
    if (initialOption) actualizarBundles(parseInt(initialOption.dataset.inventory) || 0);
  }

  var qtyInput = document.getElementById('nxp-quantity-input');

  document.querySelectorAll('.nxp-bundle').forEach(function(bundle) {
    bundle.addEventListener('click', function() {
      if (this.classList.contains('nxp-bundle-disabled')) return;
      document.querySelectorAll('.nxp-bundle').forEach(function(b) { b.classList.remove('nxp-bundle-selected'); });
      this.classList.add('nxp-bundle-selected');
      var radio = this.querySelector('input');
      if (radio) {
        radio.checked = true;
        if (qtyInput) qtyInput.value = parseInt(radio.value) || 1;
      }
    });
  });

  // Carousel
  var track = document.getElementById('nxp-carousel-track');
  var dots = document.querySelectorAll('.nxp-dot');
  var currentSlide = 0;
  function goToSlide(n) {
    currentSlide = n;
    if (track) track.style.transform = 'translateX(-' + (n * 100) + '%)';
    dots.forEach(function(d, i) { d.classList.toggle('active', i === n); });
  }
  dots.forEach(function(dot) {
    dot.addEventListener('click', function() { goToSlide(parseInt(this.dataset.idx)); });
  });
  setInterval(function() { goToSlide((currentSlide + 1) % 5); }, 4000);

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexora-lapicera-ia"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

  // Forzar 1 columna en mobile para la grilla de pasos
  function fixGridCepillo() {
    var grid = document.getElementById('nxp-reasons-grid-cepillo');
    if (grid) {
      if (window.innerWidth <= 768) {
        grid.style.setProperty('grid-template-columns', '1fr', 'important');
      } else {
        grid.style.setProperty('grid-template-columns', 'repeat(3, 1fr)', 'important');
      }
    }
  }
  fixGridCepillo();
  window.addEventListener('resize', fixGridCepillo);

  // Comprar ahora
  var btnBuy = document.getElementById('nxp-btn-buy');
  if (btnBuy) {
    btnBuy.addEventListener('click', function() {
      var variantId = document.getElementById('nxp-variant-hidden') ? document.getElementById('nxp-variant-hidden').value : null;
      var qty = document.getElementById('nxp-quantity-input') ? document.getElementById('nxp-quantity-input').value : 1;
      if (variantId) {
        window.location.href = '/checkout?variant=' + variantId + '&quantity=' + qty;
      }
    });
  }

  // Social proof rotativo
  var socialTextEl = document.getElementById('nxp-social-text');
  var compradores = [
    'Romina de Córdoba compró hace 3 minutos',
    'Valentina de CABA compró hace 7 minutos',
    'Micaela de Rosario compró hace 11 minutos',
    'Julieta de La Plata compró hace 14 minutos',
    'Camila de Mendoza compró hace 19 minutos',
    'Florencia de Santa Fe compró hace 22 minutos',
    'Natalia de Mar del Plata compró hace 28 minutos',
    'Daniela de Tucumán compró hace 31 minutos',
    'Sofía de Salta compró hace 35 minutos',
    'Luciana de Entre Ríos compró hace 41 minutos'
  ];
  function randomComprador() { return compradores[Math.floor(Math.random() * compradores.length)]; }
  if (socialTextEl) {
    socialTextEl.textContent = randomComprador();
    setInterval(function() { socialTextEl.textContent = randomComprador(); }, 15000);
  }

  // Countdown timer
  var timerEl = document.getElementById('nxp-timer');
  if (timerEl) {
    var seconds = 19 * 60 + 59;
    setInterval(function() {
      if (seconds > 0) seconds--;
      timerEl.textContent = Math.floor(seconds/60).toString().padStart(2,'0') + ':' + (seconds%60).toString().padStart(2,'0');
    }, 1000);
  }

  // Bundle selector + oversell prevention
  function actualizarBundles(stock) {
    document.querySelectorAll('.nxp-bundle').forEach(function(bundle) {
      var radio = bundle.querySelector('input');
      var qty = parseInt(radio ? radio.value : 1);
      if (qty > stock) {
        bundle.classList.add('nxp-bundle-disabled');
        if (bundle.classList.contains('nxp-bundle-selected')) {
          bundle.classList.remove('nxp-bundle-selected');
          var primerBundle = document.querySelector('.nxp-bundle');
          if (primerBundle) {
            primerBundle.classList.add('nxp-bundle-selected');
            var primerRadio = primerBundle.querySelector('input');
            if (primerRadio) {
              primerRadio.checked = true;
              var qtyInput = document.getElementById('nxp-quantity-input');
              if (qtyInput) qtyInput.value = 1;
            }
          }
        }
      } else {
        bundle.classList.remove('nxp-bundle-disabled');
      }
    });
  }

  var variantSelect = document.getElementById('nxp-variant-id');
  if (variantSelect) {
    var initialOption = variantSelect.options[variantSelect.selectedIndex];
    if (initialOption) actualizarBundles(parseInt(initialOption.dataset.inventory) || 0);
  }

  var qtyInput = document.getElementById('nxp-quantity-input');

  document.querySelectorAll('.nxp-bundle').forEach(function(bundle) {
    bundle.addEventListener('click', function() {
      if (this.classList.contains('nxp-bundle-disabled')) return;
      document.querySelectorAll('.nxp-bundle').forEach(function(b) { b.classList.remove('nxp-bundle-selected'); });
      this.classList.add('nxp-bundle-selected');
      var radio = this.querySelector('input');
      if (radio) {
        radio.checked = true;
        if (qtyInput) qtyInput.value = parseInt(radio.value) || 1;
      }
    });
  });

  // Carousel
  var track = document.getElementById('nxp-carousel-track');
  var dots = document.querySelectorAll('.nxp-dot');
  var currentSlide = 0;
  function goToSlide(n) {
    currentSlide = n;
    if (track) track.style.transform = 'translateX(-' + (n * 100) + '%)';
    dots.forEach(function(d, i) { d.classList.toggle('active', i === n); });
  }
  dots.forEach(function(dot) {
    dot.addEventListener('click', function() { goToSlide(parseInt(this.dataset.idx)); });
  });
  setInterval(function() { goToSlide((currentSlide + 1) % 5); }, 4000);

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexora-lavador-patas"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

  // Forzar 1 columna en mobile para la grilla de pasos
  function fixGridPatas() {
    var grid = document.getElementById('nxp-reasons-grid-patas');
    if (grid) {
      if (window.innerWidth <= 768) {
        grid.style.setProperty('grid-template-columns', '1fr', 'important');
      } else {
        grid.style.setProperty('grid-template-columns', 'repeat(3, 1fr)', 'important');
      }
    }
  }
  fixGridPatas();
  window.addEventListener('resize', fixGridPatas);

  // Comprar ahora
  var btnBuy = document.getElementById('nxp-btn-buy');
  if (btnBuy) {
    btnBuy.addEventListener('click', function() {
      var variantId = document.getElementById('nxp-variant-hidden') ? document.getElementById('nxp-variant-hidden').value : null;
      var qty = document.getElementById('nxp-quantity-input') ? document.getElementById('nxp-quantity-input').value : 1;
      if (variantId) {
        window.location.href = '/checkout?variant=' + variantId + '&quantity=' + qty;
      }
    });
  }

  // Social proof rotativo
  var socialTextEl = document.getElementById('nxp-social-text');
  var compradores = [
    'Romina de Córdoba compró hace 3 minutos',
    'Martín de CABA compró hace 7 minutos',
    'Micaela de Rosario compró hace 11 minutos',
    'Lucas de La Plata compró hace 14 minutos',
    'Camila de Mendoza compró hace 19 minutos',
    'Facundo de Santa Fe compró hace 22 minutos',
    'Natalia de Mar del Plata compró hace 28 minutos',
    'Diego de Tucumán compró hace 31 minutos',
    'Sofía de Salta compró hace 35 minutos',
    'Nicolás de Entre Ríos compró hace 41 minutos'
  ];
  function randomComprador() { return compradores[Math.floor(Math.random() * compradores.length)]; }
  if (socialTextEl) {
    socialTextEl.textContent = randomComprador();
    setInterval(function() { socialTextEl.textContent = randomComprador(); }, 15000);
  }

  // Countdown timer
  var timerEl = document.getElementById('nxp-timer');
  if (timerEl) {
    var seconds = 19 * 60 + 59;
    setInterval(function() {
      if (seconds > 0) seconds--;
      timerEl.textContent = Math.floor(seconds/60).toString().padStart(2,'0') + ':' + (seconds%60).toString().padStart(2,'0');
    }, 1000);
  }

  // Bundle selector + oversell prevention
  function actualizarBundles(stock) {
    document.querySelectorAll('.nxp-bundle').forEach(function(bundle) {
      var radio = bundle.querySelector('input');
      var qty = parseInt(radio ? radio.value : 1);
      if (qty > stock) {
        bundle.classList.add('nxp-bundle-disabled');
        if (bundle.classList.contains('nxp-bundle-selected')) {
          bundle.classList.remove('nxp-bundle-selected');
          var primerBundle = document.querySelector('.nxp-bundle');
          if (primerBundle) {
            primerBundle.classList.add('nxp-bundle-selected');
            var primerRadio = primerBundle.querySelector('input');
            if (primerRadio) {
              primerRadio.checked = true;
              var qtyInput = document.getElementById('nxp-quantity-input');
              if (qtyInput) qtyInput.value = 1;
            }
          }
        }
      } else {
        bundle.classList.remove('nxp-bundle-disabled');
      }
    });
  }

  var variantSelect = document.getElementById('nxp-variant-id');
  if (variantSelect) {
    var initialOption = variantSelect.options[variantSelect.selectedIndex];
    if (initialOption) actualizarBundles(parseInt(initialOption.dataset.inventory) || 0);
  }

  var qtyInput = document.getElementById('nxp-quantity-input');

  document.querySelectorAll('.nxp-bundle').forEach(function(bundle) {
    bundle.addEventListener('click', function() {
      if (this.classList.contains('nxp-bundle-disabled')) return;
      document.querySelectorAll('.nxp-bundle').forEach(function(b) { b.classList.remove('nxp-bundle-selected'); });
      this.classList.add('nxp-bundle-selected');
      var radio = this.querySelector('input');
      if (radio) {
        radio.checked = true;
        if (qtyInput) qtyInput.value = parseInt(radio.value) || 1;
      }
    });
  });

  // Carousel
  var track = document.getElementById('nxp-carousel-track');
  var dots = document.querySelectorAll('.nxp-dot');
  var currentSlide = 0;
  function goToSlide(n) {
    currentSlide = n;
    if (track) track.style.transform = 'translateX(-' + (n * 100) + '%)';
    dots.forEach(function(d, i) { d.classList.toggle('active', i === n); });
  }
  dots.forEach(function(dot) {
    dot.addEventListener('click', function() { goToSlide(parseInt(this.dataset.idx)); });
  });
  setInterval(function() { goToSlide((currentSlide + 1) % 5); }, 4000);

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexora-licuadora"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

  // Forzar 2 columnas en mobile para la grilla de pasos
  function fixGrid() {
    var grid = document.getElementById('nxp-reasons-grid-licu');
    if (grid) {
      if (window.innerWidth <= 768) {
        grid.style.setProperty('grid-template-columns', 'repeat(2, 1fr)', 'important');
      } else {
        grid.style.setProperty('grid-template-columns', 'repeat(3, 1fr)', 'important');
      }
    }
  }
  fixGrid();
  window.addEventListener('resize', fixGrid);

  // Comprar ahora
  var btnBuy = document.getElementById('nxp-btn-buy');
  if (btnBuy) {
    btnBuy.addEventListener('click', function() {
      var variantId = document.getElementById('nxp-variant-hidden') ? document.getElementById('nxp-variant-hidden').value : null;
      var qty = document.getElementById('nxp-quantity-input') ? document.getElementById('nxp-quantity-input').value : 1;
      if (variantId) {
        window.location.href = '/cart/' + variantId + ':' + (parseInt(qty) || 1) + '?checkout';
      }
    });
  }

  // Social proof rotativo
  var socialTextEl = document.getElementById('nxp-social-text');
  var compradores = [
    'Romina de Córdoba compró hace 3 minutos',
    'Martín de CABA compró hace 7 minutos',
    'Micaela de Rosario compró hace 11 minutos',
    'Lucas de La Plata compró hace 14 minutos',
    'Camila de Mendoza compró hace 19 minutos',
    'Facundo de Santa Fe compró hace 22 minutos',
    'Natalia de Mar del Plata compró hace 28 minutos',
    'Diego de Tucumán compró hace 31 minutos',
    'Sofía de Salta compró hace 35 minutos',
    'Nicolás de Entre Ríos compró hace 41 minutos'
  ];
  function randomComprador() { return compradores[Math.floor(Math.random() * compradores.length)]; }
  if (socialTextEl) {
    socialTextEl.textContent = randomComprador();
    setInterval(function() { socialTextEl.textContent = randomComprador(); }, 15000);
  }

  // Countdown timer
  var timerEl = document.getElementById('nxp-timer');
  if (timerEl) {
    var seconds = 19 * 60 + 59;
    setInterval(function() {
      if (seconds > 0) seconds--;
      timerEl.textContent = Math.floor(seconds/60).toString().padStart(2,'0') + ':' + (seconds%60).toString().padStart(2,'0');
    }, 1000);
  }

  // Bundle selector + oversell prevention
  function actualizarBundles(stock) {
    document.querySelectorAll('.nxp-bundle').forEach(function(bundle) {
      var radio = bundle.querySelector('input');
      var qty = parseInt(radio ? radio.value : 1);
      if (qty > stock) {
        bundle.classList.add('nxp-bundle-disabled');
        if (bundle.classList.contains('nxp-bundle-selected')) {
          bundle.classList.remove('nxp-bundle-selected');
          var primerBundle = document.querySelector('.nxp-bundle');
          if (primerBundle) {
            primerBundle.classList.add('nxp-bundle-selected');
            var primerRadio = primerBundle.querySelector('input');
            if (primerRadio) {
              primerRadio.checked = true;
              var qtyInput = document.getElementById('nxp-quantity-input');
              if (qtyInput) qtyInput.value = 1;
            }
          }
        }
      } else {
        bundle.classList.remove('nxp-bundle-disabled');
      }
    });
  }

  var variantSelect = document.getElementById('nxp-variant-id');
  if (variantSelect) {
    var initialOption = variantSelect.options[variantSelect.selectedIndex];
    if (initialOption) actualizarBundles(parseInt(initialOption.dataset.inventory) || 0);
  }

  var qtyInput = document.getElementById('nxp-quantity-input');

  document.querySelectorAll('.nxp-bundle').forEach(function(bundle) {
    bundle.addEventListener('click', function() {
      if (this.classList.contains('nxp-bundle-disabled')) return;
      document.querySelectorAll('.nxp-bundle').forEach(function(b) { b.classList.remove('nxp-bundle-selected'); });
      this.classList.add('nxp-bundle-selected');
      var radio = this.querySelector('input');
      if (radio) {
        radio.checked = true;
        if (qtyInput) qtyInput.value = parseInt(radio.value) || 1;
      }
    });
  });

  // Carousel
  var track = document.getElementById('nxp-carousel-track');
  var dots = document.querySelectorAll('.nxp-dot');
  var currentSlide = 0;
  function goToSlide(n) {
    currentSlide = n;
    if (track) track.style.transform = 'translateX(-' + (n * 100) + '%)';
    dots.forEach(function(d, i) { d.classList.toggle('active', i === n); });
  }
  dots.forEach(function(dot) {
    dot.addEventListener('click', function() { goToSlide(parseInt(this.dataset.idx)); });
  });
  setInterval(function() { goToSlide((currentSlide + 1) % 5); }, 4000);

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexora-portacepillos"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

  // Botón COMPRAR AHORA
  var btnBuy = document.getElementById('nxp-btn-buy');
  if (btnBuy) {
    btnBuy.addEventListener('click', function() {
      var variantId = document.getElementById('nxp-variant-hidden') ? document.getElementById('nxp-variant-hidden').value : null;
      var qty = document.getElementById('nxp-quantity-input') ? document.getElementById('nxp-quantity-input').value : 1;
      if (!variantId) return;
      window.location.href = '/cart/' + variantId + ':' + (parseInt(qty) || 1) + '?checkout';
    });
  }

  // Timer
  var timerEl = document.getElementById('nxp-timer');
  
  // Social proof viewers
  var socialTextEl = document.getElementById('nxp-social-text');
  if (socialTextEl) {
    var compradores = [
      'Martín de Buenos Aires compró hace 8 minutos',
      'Valentina de Buenos Aires compró hace 3 minutos',
      'Lucas de Buenos Aires compró hace 20 minutos',
      'Sofía de Buenos Aires compró hace 5 minutos',
      'Diego de Buenos Aires compró hace 12 minutos',
      'Camila de Buenos Aires compró hace 2 minutos',
      'Facundo de Buenos Aires compró hace 35 minutos',
      'Gonzalo de Córdoba compró hace 15 minutos',
      'Florencia de Rosario compró hace 7 minutos',
      'Nicolás de Mendoza compró hace 28 minutos',
      'Agustina de Tucumán compró hace 11 minutos',
      'Rodrigo de Mar del Plata compró hace 42 minutos',
      'Julieta de Salta compró hace 6 minutos',
      'Matías de La Plata compró hace 18 minutos',
      'Romina de Santa Fe compró hace 25 minutos'
    ];
    function randomComprador() { return compradores[Math.floor(Math.random() * compradores.length)]; }
    socialTextEl.textContent = randomComprador();
    setInterval(function() { socialTextEl.textContent = randomComprador(); }, 15000);
  }
  if (timerEl) {
    var seconds = 19 * 60 + 59;
    setInterval(function() {
      if (seconds > 0) seconds--;
      timerEl.textContent = Math.floor(seconds/60).toString().padStart(2,'0') + ':' + (seconds%60).toString().padStart(2,'0');
    }, 1000);
  }

  // ── FUNCIÓN: actualizar bundles según stock ──
  function actualizarBundles(stock) {
    document.querySelectorAll('.nxp-bundle').forEach(function(bundle) {
      var radio = bundle.querySelector('input');
      var qty = parseInt(radio ? radio.value : 1);
      if (qty > stock) {
        bundle.classList.add('nxp-bundle-disabled');
        if (bundle.classList.contains('nxp-bundle-selected')) {
          bundle.classList.remove('nxp-bundle-selected');
          var primerBundle = document.querySelector('.nxp-bundle');
          if (primerBundle) {
            primerBundle.classList.add('nxp-bundle-selected');
            var primerRadio = primerBundle.querySelector('input');
            if (primerRadio) {
              primerRadio.checked = true;
              var qtyInput = document.getElementById('nxp-quantity-input');
              if (qtyInput) qtyInput.value = 1;
            }
          }
        }
      } else {
        bundle.classList.remove('nxp-bundle-disabled');
      }
    });
  }

  // Ejecutar al cargar con variante inicial
  var variantSelect = document.getElementById('nxp-variant-id');
  if (variantSelect) {
    var initialOption = variantSelect.options[variantSelect.selectedIndex];
    if (initialOption) actualizarBundles(parseInt(initialOption.dataset.inventory) || 0);
  }

  var qtyInput = document.getElementById('nxp-quantity-input');

  // Bundle selector
  document.querySelectorAll('.nxp-bundle').forEach(function(bundle) {
    bundle.addEventListener('click', function() {
      if (this.classList.contains('nxp-bundle-disabled')) return;
      document.querySelectorAll('.nxp-bundle').forEach(function(b) { b.classList.remove('nxp-bundle-selected'); });
      this.classList.add('nxp-bundle-selected');
      var radio = this.querySelector('input');
      if (radio) {
        radio.checked = true;
        if (qtyInput) qtyInput.value = parseInt(radio.value) || 1;
      }
    });
  });

  // Carousel
  var track = document.getElementById('nxp-carousel-track');
  var dots = document.querySelectorAll('.nxp-dot');
  var currentSlide = 0;
  function goToSlide(n) { currentSlide = n; if (track) track.style.transform = 'translateX(-' + (n * 100) + '%)'; dots.forEach(function(d, i) { d.classList.toggle('active', i === n); }); }
  dots.forEach(function(dot) { dot.addEventListener('click', function() { goToSlide(parseInt(this.dataset.idx)); }); });
  setInterval(function() { goToSlide((currentSlide + 1) % 5); }, 4000);

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexora-product-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

  // Timer
  var timerEl = document.getElementById('nxr-timer');
  if (timerEl) {
    var seconds = 9 * 60 + 59;
    setInterval(function() {
      if (seconds > 0) seconds--;
      timerEl.textContent = Math.floor(seconds/60).toString().padStart(2,'0') + ':' + (seconds%60).toString().padStart(2,'0');
    }, 1000);
  }

  // ── FUNCIÓN: actualizar bundles según stock disponible ──
  function actualizarBundles(stock) {
    document.querySelectorAll('.nxr-bundle').forEach(function(bundle) {
      var radio = bundle.querySelector('input');
      var qty = parseInt(radio ? radio.value : 1);
      if (qty > stock) {
        bundle.classList.add('nxr-bundle-disabled');
        // Si este bundle estaba seleccionado, deseleccionarlo
        if (bundle.classList.contains('nxr-bundle-selected')) {
          bundle.classList.remove('nxr-bundle-selected');
          // Seleccionar el bundle de 1 como fallback
          var primerBundle = document.querySelector('.nxr-bundle');
          if (primerBundle) {
            primerBundle.classList.add('nxr-bundle-selected');
            var primerRadio = primerBundle.querySelector('input');
            if (primerRadio) primerRadio.checked = true;
          }
        }
      } else {
        bundle.classList.remove('nxr-bundle-disabled');
      }
    });
  }

  // Ejecutar al cargar con la variante inicial
  var variantSelect = document.getElementById('nxr-variant-id');
  if (variantSelect) {
    var initialOption = variantSelect.options[variantSelect.selectedIndex];
    if (initialOption) {
      actualizarBundles(parseInt(initialOption.dataset.inventory) || 0);
    }
  }

  // Variant selector
  document.querySelectorAll('.nxr-opt input').forEach(function(radio) {
    radio.addEventListener('change', function() {
      // Update active styles
      var optionIndex = this.dataset.optionIndex;
      document.querySelectorAll('[data-option-index="' + optionIndex + '"] .nxr-opt').forEach(function(el) {
        el.classList.remove('nxr-opt-active');
      });
      this.closest('.nxr-opt').classList.add('nxr-opt-active');
      // Find matching variant
      var opts = {};
      document.querySelectorAll('.nxr-opt input:checked').forEach(function(r) {
        opts[r.dataset.optionIndex] = r.value;
      });
      var options = document.querySelectorAll('[name^="options"]');
      var sel = Array.from({length: options.length}, function(_, i) { return opts[i] || ''; });
      var matchingOption = null;
      Array.from(variantSelect.options).forEach(function(opt) {
        if (
          opt.dataset.option1 === (sel[0] || '') &&
          (sel[1] === '' || opt.dataset.option2 === sel[1]) &&
          (sel[2] === '' || opt.dataset.option3 === sel[2])
        ) {
          matchingOption = opt;
        }
      });
      if (matchingOption) {
        variantSelect.value = matchingOption.value;
        // Update image
        if (matchingOption.dataset.img) {
          var img = document.getElementById('nxr-main-img');
          if (img) img.src = matchingOption.dataset.img;
        }
        // Update cart button
        var btn = document.querySelector('.nxr-btn-cart');
        if (btn) {
          if (matchingOption.dataset.available === 'true') {
            btn.disabled = false;
            btn.textContent = '🛒 AGREGAR AL CARRITO';
          } else {
            btn.disabled = true;
            btn.textContent = 'SIN STOCK';
          }
        }
        // ── Validar bundles según stock de la variante seleccionada ──
        actualizarBundles(parseInt(matchingOption.dataset.inventory) || 0);

        // Update URL
        var url = new URL(window.location.href);
        url.searchParams.set('variant', matchingOption.value);
        window.history.replaceState({}, '', url.toString());
      }
    });
  });

  // Bundle selector
  document.querySelectorAll('.nxr-bundle').forEach(function(bundle) {
    bundle.addEventListener('click', function() {
      if (this.classList.contains('nxr-bundle-disabled')) return;
      document.querySelectorAll('.nxr-bundle').forEach(function(b) { b.classList.remove('nxr-bundle-selected'); });
      this.classList.add('nxr-bundle-selected');
      var radio = this.querySelector('input');
      if (radio) radio.checked = true;
    });
  });

  // Carousel
  var track = document.getElementById('nxr-carousel-track');
  var dots = document.querySelectorAll('.nxr-dot');
  var currentSlide = 0;
  function goToSlide(n) {
    currentSlide = n;
    if (track) track.style.transform = 'translateX(-' + (n * 100) + '%)';
    dots.forEach(function(d, i) { d.classList.toggle('active', i === n); });
  }
  dots.forEach(function(dot) { dot.addEventListener('click', function() { goToSlide(parseInt(this.dataset.idx)); }); });
  setInterval(function() { goToSlide((currentSlide + 1) % 5); }, 4000);

  // Slider comparativo
  var sliderEl = document.getElementById('nxr-slider-container');
  var beforeEl = document.getElementById('nxr-before-wrap');
  var handleEl = document.getElementById('nxr-handle');
  if (sliderEl && beforeEl && handleEl) {
    var dragging = false;
    function move(x) {
      var r = sliderEl.getBoundingClientRect();
      var pct = Math.min(Math.max((x - r.left) / r.width, 0.05), 0.95);
      beforeEl.style.width = (pct * 100) + '%';
      handleEl.style.left = (pct * 100) + '%';
    }
    sliderEl.addEventListener('mousedown', function(e) { dragging = true; move(e.clientX); });
    window.addEventListener('mousemove', function(e) { if (dragging) move(e.clientX); });
    window.addEventListener('mouseup', function() { dragging = false; });
    sliderEl.addEventListener('touchstart', function(e) { dragging = true; move(e.touches[0].clientX); }, {passive: true});
    window.addEventListener('touchmove', function(e) { if (dragging) move(e.touches[0].clientX); }, {passive: true});
    window.addEventListener('touchend', function() { dragging = false; });
  }

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nexora-trampa-uv"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

  // Forzar 1 columna en mobile para la grilla de pasos
  function fixGridUV() {
    var grid = document.getElementById('nxp-reasons-grid-uv');
    if (grid) {
      if (window.innerWidth <= 768) {
        grid.style.setProperty('grid-template-columns', '1fr', 'important');
      } else {
        grid.style.setProperty('grid-template-columns', 'repeat(3, 1fr)', 'important');
      }
    }
  }
  fixGridUV();
  window.addEventListener('resize', fixGridUV);

  // Comprar ahora
  var btnBuy = document.getElementById('nxp-btn-buy');
  if (btnBuy) {
    btnBuy.addEventListener('click', function() {
      var variantId = document.getElementById('nxp-variant-hidden') ? document.getElementById('nxp-variant-hidden').value : null;
      var qty = document.getElementById('nxp-quantity-input') ? document.getElementById('nxp-quantity-input').value : 1;
      if (variantId) {
        window.location.href = '/checkout?variant=' + variantId + '&quantity=' + qty;
      }
    });
  }

  // Social proof rotativo
  var socialTextEl = document.getElementById('nxp-social-text');
  var compradores = [
    'Romina de Córdoba compró hace 3 minutos',
    'Martín de CABA compró hace 7 minutos',
    'Micaela de Rosario compró hace 11 minutos',
    'Lucas de La Plata compró hace 14 minutos',
    'Camila de Mendoza compró hace 19 minutos',
    'Facundo de Santa Fe compró hace 22 minutos',
    'Natalia de Mar del Plata compró hace 28 minutos',
    'Diego de Tucumán compró hace 31 minutos',
    'Sofía de Salta compró hace 35 minutos',
    'Nicolás de Entre Ríos compró hace 41 minutos'
  ];
  function randomComprador() { return compradores[Math.floor(Math.random() * compradores.length)]; }
  if (socialTextEl) {
    socialTextEl.textContent = randomComprador();
    setInterval(function() { socialTextEl.textContent = randomComprador(); }, 15000);
  }

  // Countdown timer
  var timerEl = document.getElementById('nxp-timer');
  if (timerEl) {
    var seconds = 19 * 60 + 59;
    setInterval(function() {
      if (seconds > 0) seconds--;
      timerEl.textContent = Math.floor(seconds/60).toString().padStart(2,'0') + ':' + (seconds%60).toString().padStart(2,'0');
    }, 1000);
  }

  // Bundle selector + oversell prevention
  function actualizarBundles(stock) {
    document.querySelectorAll('.nxp-bundle').forEach(function(bundle) {
      var radio = bundle.querySelector('input');
      var qty = parseInt(radio ? radio.value : 1);
      if (qty > stock) {
        bundle.classList.add('nxp-bundle-disabled');
        if (bundle.classList.contains('nxp-bundle-selected')) {
          bundle.classList.remove('nxp-bundle-selected');
          var primerBundle = document.querySelector('.nxp-bundle');
          if (primerBundle) {
            primerBundle.classList.add('nxp-bundle-selected');
            var primerRadio = primerBundle.querySelector('input');
            if (primerRadio) {
              primerRadio.checked = true;
              var qtyInput = document.getElementById('nxp-quantity-input');
              if (qtyInput) qtyInput.value = 1;
            }
          }
        }
      } else {
        bundle.classList.remove('nxp-bundle-disabled');
      }
    });
  }

  var variantSelect = document.getElementById('nxp-variant-id');
  if (variantSelect) {
    var initialOption = variantSelect.options[variantSelect.selectedIndex];
    if (initialOption) actualizarBundles(parseInt(initialOption.dataset.inventory) || 0);
  }

  var qtyInput = document.getElementById('nxp-quantity-input');

  document.querySelectorAll('.nxp-bundle').forEach(function(bundle) {
    bundle.addEventListener('click', function() {
      if (this.classList.contains('nxp-bundle-disabled')) return;
      document.querySelectorAll('.nxp-bundle').forEach(function(b) { b.classList.remove('nxp-bundle-selected'); });
      this.classList.add('nxp-bundle-selected');
      var radio = this.querySelector('input');
      if (radio) {
        radio.checked = true;
        if (qtyInput) qtyInput.value = parseInt(radio.value) || 1;
      }
    });
  });

  // Carousel
  var track = document.getElementById('nxp-carousel-track');
  var dots = document.querySelectorAll('.nxp-dot');
  var currentSlide = 0;
  function goToSlide(n) {
    currentSlide = n;
    if (track) track.style.transform = 'translateX(-' + (n * 100) + '%)';
    dots.forEach(function(d, i) { d.classList.toggle('active', i === n); });
  }
  dots.forEach(function(dot) {
    dot.addEventListener('click', function() { goToSlide(parseInt(this.dataset.idx)); });
  });
  setInterval(function() { goToSlide((currentSlide + 1) % 5); }, 4000);

});

  } catch(e) { console.error(e); }
})();
})();
